import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
  standalone: false,
  selector: 'app-hazards-account-hierarchy-of-controls',
  templateUrl: './hazards-account-hierarchy-of-controls.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./hazards-account-hierarchy-of-controls.component.scss']
})
export class HazardsAccountHierarchyOfControlsComponent implements OnInit {
  constructor(public app: AppService) {}

  ngOnInit() {}
}
